<template>
  <div class="new-promotion">
    <div class="banner-box">
      <img class="banner-img" :src="bannerImg" />

      <div class="logo-box">
        <img class="logo-img" :src="bannerLogoImg" />
      </div>
      <div class="tag-box">
        <img class="aeo-icon" :src="bannerIcon1" />
        <img class="cctv-icon" :src="bannerIcon2" />
      </div>
    </div>

    <div class="form-box" id="formBox">
      <img class="bg-icon bg-icon-1" :src="bgIcon1" />
      <img class="bg-icon bg-icon-2" :src="bgIcon2" />
      <img class="bg-icon bg-icon-3" :src="bgIcon3" />
      <img class="bg-icon bg-icon-4" :src="bgIcon4" />
      <img class="bg-icon bg-icon-5" :src="bgIcon5" />

      <div class="g-container-width">
        <div class="content">
          <div class="form">
            <ht-form />
          </div>

          <div class="text-box">
            <h3 class="title-text">中文学习大礼包</h3>
            <ul class="text-list-box">
              <li class="text-list-item">
                <img class="item-text-icon" :src="textIcon1" />
                <div class="item-text-box">
                  <h5 class="text-title">2节试读体验课</h5>
                  <p class="text-desc">
                    1V1名师课、评测报告、成长规划、名师答疑
                  </p>
                </div>
              </li>
              <!-- <li class='text-list-item'>
                                <img class='item-text-icon' :src='textIcon2' />
                                <div class='item-text-box'>
                                    <h5 class='text-title'>16节中华文化兴趣课</h5>
                                    <p class='text-desc'>《城市与美食》从城市发展、经典故事、景点科普、中华美食、艺术文物等多角度详细介绍中国经典城市风貌，为孩子呈现一个完整的中华城市印象。</p>
                                </div>
                            </li> -->
              <li class="text-list-item">
                <img class="item-text-icon" :src="textIcon3" />
                <div class="item-text-box">
                  <h5 class="text-title">哈兔书房VIP</h5>
                  <p class="text-desc">
                    书房内含1000多本AI交互动画书，每1本书都有丰富的动画、多媒体和互动效果，孩子在阅读时通过多点触摸、摇晃动作玩游戏的方式与动画书指尖互动，让孩子随时随地畅享阅读的喜悦！
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div
      class="teaching-server"
      :style="{ backgroundImage: `url(${teachingServerBg})` }"
    >
      <div class="g-container-width">
        <div class="content">
          <h3 class="title-text">提供高品质教学服务</h3>
          <van-row class="list" :gutter="10" type="flex">
            <van-col
              :span="6"
              v-for="(item, index) in teachingServerList"
              class="list-item"
              :key="index"
            >
              <div class="list-item-content">
                <img class="icon" :src="item.icon" />
                <div class="num num-animate-box">
                  <count-to
                    :startVal="0"
                    :endVal="item.num"
                    :duration="1000"
                    spearator=","
                  ></count-to>
                  +
                </div>
                <p class="desc">{{ item.title }}</p>
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>

    <div class="cctv" :style="{ backgroundImage: `url(${cctvBgIcon})` }">
      <div class="g-container-width">
        <h2 class="content-title">值得信赖，央视专题报道</h2>
        <div class="content">
          <div class="video-box">
            <HtVideo
              src="https://hatu-cdn.oss-cn-hangzhou.aliyuncs.com/hatu-unnc/assets/index/CCTV_video.mp4"
              :poster="cctvPosterIcon"
            />
          </div>
          <div class="desc-box">
            <h5 class="desc-title">央视中文国际频道（CCTV-4）讲述“哈兔故事”</h5>
            <ul class="desc-text-box">
              <li class="desc-text">
                <p class="text">
                  哈兔中文网络学院创办于2012年，专注为海外华侨华人孩子和全球中文爱好者提供专业在线中文教育。哈兔的在线中文课堂已覆盖全球<b>120</b>多个国家和地区，在线注册学员已超过<b>150,000</b>人，在线专业资深老师超过<b>3,000</b>人。
                </p>
              </li>
              <li class="desc-text">
                <p class="text">
                  2018年10月，中央电视台《走遍中国》栏目摄制组走进哈兔中文，进行了为期一周的专题采访，对哈兔中文创始人朱敏院长进行了专访，深度介绍了哈兔创始团队坚持
                  让天下人学中文不再难”的使命，面向全球开展在线中文教育和传播中华文化的心路历程。
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="classroom">
      <div>
        <h2 class="content-title">一个有趣的在线中文课堂</h2>

        <p class="sub-content-title">趣味与实用兼具的在线中文课堂</p>

        <div class="content">
          <div class="classroom-info">
            <div class="teaching-box">
              <ul class="list">
                <li
                  v-for="(item, index) in teachingList"
                  :key="index"
                  :class="
                    `list-item ${
                      item.index - 1 === curTeachingIndex
                        ? 'list-item-active'
                        : ''
                    }`
                  "
                  @click="selectTeaching(item, index)"
                >
                  <span class="num">{{ item.index }}</span>
                  <img class="icon" :src="item.icon" />
                  <p class="value">{{ item.label }}</p>
                </li>
              </ul>
            </div>

            <div class="video-box">
              <h6 class="title-text">
                {{ teachingList[curTeachingIndex].label }}
              </h6>
              <p class="desc">{{ teachingList[curTeachingIndex].content }}</p>
              <div class="video-conteainer">
                <HtVideo
                  src="https://hatu-cdn.oss-cn-hangzhou.aliyuncs.com/hatu-unnc/assets/index/teaching_video.mp4"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="course-box" :style="{ backgroundImage: `url(${coursebg})` }">
      <div class="content">
        <div class="title-box">
          <h3 class="title-text">好课程，自主研发中文课程</h3>
          <p class="title-desc">
            哈兔教研团队自主研发专为海外华人青少儿定制的中文课程，均获得国家版权中心认证
          </p>
          <p class="title-desc">
            3大类40+中文课程满足不同水平学习者的不同学习需求
          </p>
        </div>
        <div class="swiper-box">
          <div class="swiper-container swiper-container-course">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide swiper-slide-item"
                v-for="(item, index) in courseList"
                :key="index"
              >
                <img
                  class="book"
                  :src="item.verticalImages"
                  :alt="item.title"
                />
                <img class="book-shadow" :src="bookShadow" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="teacher-box">
      <div class="content">
        <div>
          <div class="title-box">
            <h3 class="title-text">好老师，懂教育爱孩子</h3>
            <p class="title-desc">
              全球3000+资深老师，均来自于国内外知名大学，在线教学经验丰富，精通儿童教育心理学，在趣味课堂中
            </p>
            <p class="title-desc">
              亦师亦友相伴成长，让学员的每一堂课都学有所获。
            </p>
          </div>

          <div class="swiper-box">
            <div class="swiper-container swiper-container-teacher">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(arr, index) in teacherList"
                  :key="index"
                >
                  <div class="swiper-slide-item">
                    <div class="pic-box">
                      <ht-video :src="arr.video" :isDialogPlay="false">
                        <div class="teacher-img-box">
                          <img class="teacher-pic" :src="arr.photo" />
                          <div class="teacher-info-box">
                            <div class="teacher-text">
                              <p class="teacher-name">{{ arr.name }}</p>
                              <p class="teahcer-education">
                                {{ arr.school }} {{ arr.highestEducation }}
                              </p>
                            </div>
                            <img class="play-icon" :src="playIcon" />
                          </div>
                        </div>
                      </ht-video>
                    </div>
                    <div class="teacher-introduce-box">
                      <p class="teacher-lang">掌握语言：{{ arr.language }}</p>
                      <div class="teacher-experience">
                        <div class="experience-item">
                          <img class="icon" :src="studentIcon" />
                          <img
                            class="icon icon-white"
                            :src="studentWhiteIcon"
                          />
                          <p class="value">{{ arr.studentNum }}名在读学生</p>
                        </div>
                        <div class="experience-item">
                          <img class="icon" :src="lessonsIcon" />
                          <img
                            class="icon icon-white"
                            :src="lessonsWhiteIcon"
                          />
                          <p class="value">累计授课{{ arr.lessonNum }}节</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="comment">
      <div class="title-box">
        <p class="title-text">学员和家长的评价</p>
      </div>

      <img class="bg-img" :src="commentBgIcon" />

      <div class="g-container-width">
        <div class="content">
          <div class="comment-box">
            <div class="swiper-box">
              <div class="swiper-container swiper-container-comment">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(arr, index) in commentList"
                    :key="index"
                  >
                    <div class="comment-item">
                      <div class="video-box">
                        <img class="img" :src="arr.cover" />
                      </div>
                      <div class="info-box">
                        <p class="name">{{ arr.studentName }}</p>
                        <div class="info-text">
                          <span class="line"></span>
                          <img class="symbal" :src="symbalIcon" />
                          <p class="comment g-ellipsis-eight">
                            {{ arr.remarks }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="swiper-pagination-comment"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="step-box">
      <div>
        <h2 class="content-title">简单3步，免费试听！</h2>

        <div class="steps-box">
          <index-steps />
        </div>

        <div>
          <div class="apply-btn" @click="toForm">立即免费领取试读体验课</div>
        </div>
      </div>
    </div>

    <div class="bottom-img-box">
      <img class="bottom-img" :src="bottomImg" />
    </div>

    <div class="foonter-box" :style="{ backgroundImage: `url(${footerBg})` }">
      <div class="g-container-width">
        <div class="logo-box">
          <img class="footer-logo" :src="footerLogo" />
        </div>

        <div class="copyright">
          <p class="copyright-num">
            IHATOOS2020哈免中文网络科技有限公司-浙ICP备15040512号
          </p>
          <p class="aeo">国高认证</p>
        </div>
      </div>
    </div>

    <div class="fiexd-btn" id="footer">
      <div class="btn" @click="toForm">立即免费试读体验</div>
    </div>
  </div>
</template>

<script>
import bannerImg from "@/assets/newPromotionImg/banner.png";
import bannerIcon1 from "@/assets/newPromotionImg/banner_icon_1.png";
import bannerIcon2 from "@/assets/newPromotionImg/banner_icon_2.png";
import bannerLogoImg from "@/assets/newPromotionImg/banner_logo.png";
import bgIcon1 from "@/assets/newPromotionImg/bg_icon_1.svg";
import bgIcon2 from "@/assets/newPromotionImg/bg_icon_2.svg";
import bgIcon3 from "@/assets/newPromotionImg/bg_icon_3.svg";
import bgIcon4 from "@/assets/newPromotionImg/bg_icon_4.svg";
import bgIcon5 from "@/assets/newPromotionImg/bg_icon_5.png";
import textIcon1 from "@/assets/newPromotionImg/text_icon_1.svg";
import textIcon2 from "@/assets/newPromotionImg/text_icon_2.svg";
import textIcon3 from "@/assets/newPromotionImg/text_icon_3.svg";
import teachingServerBg from "@/assets/newPromotionImg/teaching_server_bg.png";
import teachingServerIcon1 from "@/assets/newPromotionImg/teaching_server_icon_1.svg";
import teachingServerIcon2 from "@/assets/newPromotionImg/teaching_server_icon_2.svg";
import teachingServerIcon3 from "@/assets/newPromotionImg/teaching_server_icon_3.svg";
import teachingServerIcon4 from "@/assets/newPromotionImg/teaching_server_icon_4.svg";
import cctvBgIcon from "@/assets/newPromotionImg/cctv_bg.svg";
import cctvPosterIcon from "@/assets/newPromotionImg/cctv_poster.png";
import teachingIcon1 from "@/assets/newPromotionImg/teaching_icon_1.svg";
import teachingIcon2 from "@/assets/newPromotionImg/teaching_icon_2.svg";
import teachingIcon3 from "@/assets/newPromotionImg/teaching_icon_3.svg";
import teachingIcon4 from "@/assets/newPromotionImg/teaching_icon_4.svg";
import coursebg from "@/assets/newPromotionImg/course_bg.svg";
import bookShadow from "@/assets/newPromotionImg/book_shadow_icon.svg";
import playIcon from "@/assets/newPromotionImg/play.svg";
import studentIcon from "@/assets/newPromotionImg/student.svg";
import studentWhiteIcon from "@/assets/newPromotionImg/student_white.svg";
import lessonsIcon from "@/assets/newPromotionImg/lessons.svg";
import lessonsWhiteIcon from "@/assets/newPromotionImg/lessons_white.svg";
import commentBgIcon from "@/assets/newPromotionImg/comment_bg.png";
import symbalIcon from "@/assets/newPromotionImg/symbal.png";
import bottomImg from "@/assets/newPromotionImg/bottom_img.png";
import footerBg from "@/assets/newPromotionImg/footer_bg.png";
import footerLogo from "@/assets/newPromotionImg/footer_logo.png";

import HtForm from "@/components/HtForm";
import HtVideo from "@/components/HtVideo";
import IndexSteps from "@/components/IndexSteps";
import Swiper from "swiper";
import CountTo from "vue-count-to";
import { getCourseList, getTeacherList, getCommentList } from "@/apis/league";

export default {
  components: {
    HtForm,
    HtVideo,
    IndexSteps,
    CountTo
  },

  data() {
    return {
      bannerImg,
      bannerIcon1,
      bannerIcon2,
      bannerLogoImg,
      bgIcon1,
      bgIcon2,
      bgIcon3,
      bgIcon4,
      bgIcon5,
      textIcon1,
      textIcon2,
      textIcon3,
      teachingServerBg,
      cctvBgIcon,
      cctvPosterIcon,
      coursebg,
      bookShadow,
      playIcon,
      studentIcon,
      studentWhiteIcon,
      lessonsIcon,
      lessonsWhiteIcon,
      commentBgIcon,
      symbalIcon,
      bottomImg,
      footerBg,
      footerLogo,

      teachingServerList: [
        {
          icon: teachingServerIcon1,
          num: 0,
          title: "自主研发中文课程"
        },
        {
          icon: teachingServerIcon2,
          num: 0,
          title: "中文课堂覆盖国家和地区"
        },
        {
          icon: teachingServerIcon3,
          num: 0,
          title: "优选资深中文教师"
        },
        {
          icon: teachingServerIcon4,
          num: 0,
          title: "哈兔学员遍布全球"
        }
      ],
      teachingList: [
        {
          index: 1,
          icon: teachingIcon1,
          label: "真人实时教学",
          content:
            "在线视频面对面互动教学，能及时发现学员的学习状态，灵活调整适合学员的教学方法。"
        },
        {
          index: 2,
          icon: teachingIcon2,
          label: "沉浸式教学",
          content:
            "将现实场号投射到在线课堂中，让学员在自然真实的环境中学习和使用中文，潜移默化地提升学习效果。"
        },
        {
          index: 3,
          icon: teachingIcon3,
          label: "多媒体课件",
          content:
            "课件充分利用多媒体技术:融合大量精美图片、音频、视频和GIF动图等内容，吸引学员注意力。"
        },
        {
          index: 4,
          icon: teachingIcon4,
          label: "丰富课堂互动",
          content:
            "每节课设置有趣的交互型游戏，让学生充分参与到课章中，使教学更生动、练习更有趣!"
        }
      ],
      curTeachingIndex: 0,

      courseList: [],
      teacherList: [],
      commentList: []
    };
  },

  mounted() {
    document.title = "哈兔中文免费试读体验课-好课程，好老师，好效果！";

    window.ttq.instance(window.HPixelId).track("ViewContent", {
      query: window.location.hash.split("?")[1]
      // "test_event_code": 'TEST22841'
    });

    const target = document.querySelectorAll(".num-animate-box");
    const callback = (entries, observer) => {
      entries.forEach(entrie => {
        if (entrie.isIntersecting) {
          this.teachingServerList[0].num = 40;
          this.teachingServerList[1].num = 120;
          this.teachingServerList[2].num = 3000;
          this.teachingServerList[3].num = 15000;
        } else {
          this.teachingServerList[0].num = 0;
          this.teachingServerList[1].num = 0;
          this.teachingServerList[2].num = 0;
          this.teachingServerList[3].num = 0;
        }
      });
    };
    const options = {};
    const observer = new IntersectionObserver(callback, options);
    target.forEach(el => {
      observer.observe(el);
    });

    this.getCourseList();
    this.getTeacherList();
    this.getCommentList();

    function IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }

    //rem自适应
    if (IsPC()) {
      let dom = document.querySelector("#footer");
      dom.style.width = "375px";
      dom.style.left = "50%";
      dom.style.transform = "translateX(-50%)";
    }
  },

  methods: {
    selectTeaching(it, index) {
      this.curTeachingIndex = index;
    },

    getCourseList() {
      getCourseList({
        categoryId: 8
      }).then(res => {
        this.courseList = res.data;
        this.$nextTick(() => {
          this.initCourseSwiper();
        });
      });
    },

    initCourseSwiper() {
      new Swiper(".swiper-container-course", {
        slidesPerView: 3,
        spaceBetween: 43,
        height: "auto",
        loop: true,
        autoplay: {
          delay: 1000
        }
      });
    },

    initTeacherSwiper() {
      new Swiper(".swiper-container-teacher", {
        slidesPerView: 1,
        spaceBetween: 26,
        height: "auto",
        loop: true,
        effect: "coverflow",
        coverflowEffect: {
          rotate: 0,
          stretch: "25%",
          depth: 100,
          modifier: 1,
          slideShadows: false
        },
        autoplay: {
          delay: 3000
        }
      });
    },

    getTeacherList() {
      getTeacherList({
        type: 1
      }).then(res => {
        this.teacherList = res.data;
        this.$nextTick(() => {
          this.initTeacherSwiper();
        });
      });
    },

    getCommentList() {
      getCommentList({
        appId: "ihatoo"
      }).then(res => {
        this.commentList = res.data;
        this.$nextTick(() => {
          this.initCommentSwiper();
        });
      });
    },

    initCommentSwiper() {
      new Swiper(".swiper-container-comment", {
        slidesPerView: 2,
        spaceBetween: 2,
        height: "auto",
        loop: true,
        autoplay: {
          delay: 30000
        },
        pagination: {
          el: ".swiper-pagination-comment",
          bulletClass: "swiper-pagination-comment-bullet",
          bulletActiveClass: "swiper-pagination-comment-bullet-active",
          clickable: true
        }
      });
    },

    toForm() {
      let formBox = document.getElementById("formBox");
      window.scrollTo({
        top: formBox.offsetTop,
        behavior: "smooth"
      });
      console.log(5522);
      window.ttq.instance(window.HPixelId).track("ClickButton", {
        query: window.location.hash.split("?")[1]
        // "test_event_code": 'TEST22841'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<style lang="scss">
.swiper-pagination-comment {
  margin: -20px auto 0 auto;
  position: relative;
  z-index: 3;
  width: 30%;
  height: 3px;
  background-color: #e8e8e8;
  border-radius: 2px;
  display: flex;
  align-items: center;

  .swiper-pagination-comment-bullet {
    width: 20px;
    height: 100%;
    border-radius: 2px;
  }

  .swiper-pagination-comment-bullet-active {
    background-color: #f87a10;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPromotion/index.vue